import React from "react";

export default (props) =>{
    const {show,details} = props;
    if(show && !details){
        return (
            <div className="col-12 text-center p-5">  
                <h4>We are unable to provide an online quote based on the entered information. 
                To discuss your mortgage options, please contact a Mountain America Mortgage Specialist at 1-800-277-7703. You may also try adjusting the quote information.</h4>
            </div>
        );
    }
    return null;
    
};

